/**
 * Tools Page Entry Point
 * Mounts React components for tools pages
 */

import React from 'react'
import { createRoot } from 'react-dom/client'

// Import components
import ChineseWorksheet from 'components/tools/ChineseWorksheet'
import CtaBanner from 'components/tools/CtaBanner'

// Get translations from data attribute
const getTranslations = (container) => {
  try {
    const translationsAttr = container?.dataset?.translations
    return translationsAttr ? JSON.parse(translationsAttr) : {}
  } catch (e) {
    console.warn('Failed to parse translations:', e)
    return {}
  }
}

// ⛔ The tools index list is server-rendered (app/views/tools/index.html.erb).
// It used to mount here, which left the crawler an empty div where every link
// on the page was. It has no state and no interaction, so React bought nothing.

// Mount ChineseWorksheet component on worksheet page
const worksheetContainer = document.getElementById('chinese-worksheet-app')
if (worksheetContainer) {
  const translations = getTranslations(worksheetContainer)
  const root = createRoot(worksheetContainer)
  root.render(<ChineseWorksheet translations={translations} />)
}

// Mount CTA Banner on worksheet page
const ctaBannerContainer = document.getElementById('tools-cta-banner')
if (ctaBannerContainer) {
  const translations = getTranslations(ctaBannerContainer)
  const root = createRoot(ctaBannerContainer)
  root.render(<CtaBanner translations={translations} userSignedIn={translations.user_signed_in} />)
}
